export const FONT = "'Montserrat', sans-serif";

export const summaryLabelSx = {
  fontFamily: FONT,
  fontWeight: 600,
  fontSize: "14px",
  lineHeight: "100%",
  color: "#5a6a7e",
};

export const summaryValueSx = {
  fontFamily: FONT,
  fontWeight: 400,
  fontSize: "26px",
  lineHeight: "18px",
  letterSpacing: "0%",
  verticalAlign: "bottom",
  color: "#1a2a3a",
};

export const thSx = {
  backgroundColor: "#003771 !important",
  color: "#ffffff !important",
  fontFamily: FONT,
  fontWeight: 700,
  fontSize: "12px",
  textTransform: "uppercase" as const,
  letterSpacing: "0.4px",
  height: 50,
  padding: "8px 15px 8px 20px",
  borderRight: "none",
  boxShadow: "inset -2px 0 0 #fff",
  textAlign: "center" as const,
  position: "sticky" as const,
  top: 0,
  zIndex: 2,
  whiteSpace: "nowrap" as const,
  overflow: "hidden" as const,
  boxSizing: "border-box" as const,
};

export const thLastSx = {
  ...thSx,
  boxShadow: "none",
  borderRight: "24px solid transparent",
};

export const tdSx = {
  fontFamily: FONT,
  fontSize: "13px",
  color: "#1a2a3a !important",
  backgroundColor: "inherit !important",
  height: 50,
  padding: "8px 15px",
  display: "table-cell",
  textAlign: "center" as const,
  borderRight: "none",
  borderBottom: "1px solid rgba(0,0,0,0.06)",
  verticalAlign: "middle" as const,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap" as const,
};

export const tdLastSx = {
  ...tdSx,
  borderRight: "24px solid transparent",
};

export const dashboardHeaderTextSx = {
  fontFamily: "Montserrat",
  fontWeight: 600,
  fontSize: "14px",
  color: "#131212ff",
  opacity: 0.9,
};

export const dashboardSectionHeaderSx = {
  px: 0.5,
  pb: 1,
  minHeight: 28,
  display: "flex",
  alignItems: "center",
};

export const placeholderCardSx = {
  width: "100%",
  minHeight: 358,
  borderRadius: "8px",
  border: "2px dashed #D4D8E1",
  backgroundColor: "#EEF2F7",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#7C8493",
  fontSize: "13px",
  fontWeight: 500,
  boxSizing: "border-box",
};